import { inject, Injectable, signal } from '@angular/core';
import { ComplaintRepository } from '../repositories/complaint.repository';
import { ComplaintCreateRequest } from '../types/complaint-create-request';
import { ComplaintResponse } from '../types/complaint-response';
import {
  ComplaintSignatureCreateRequest,
  ComplaintSignatureRole,
} from '../types/complaint-signature';

@Injectable()
export class ComplaintService {
  private readonly repository = inject(ComplaintRepository);

  readonly selectedDeviceId = signal<string | null>(null);

  readonly isSaving = signal(false);
  readonly error = signal<unknown>(null);

  readonly isFinalizing = signal(false);
  readonly pdf = signal<Blob | null>(null);
  readonly pdfError = signal<unknown>(null);

  async create(value: ComplaintCreateRequest): Promise<ComplaintResponse> {
    this.isSaving.set(true);
    this.error.set(null);
    try {
      return await this.repository.create(value);
    } catch (e) {
      this.error.set(e);
      throw e;
    } finally {
      this.isSaving.set(false);
    }
  }

  async finalize(id: number): Promise<void> {
    this.isFinalizing.set(true);
    this.pdfError.set(null);
    try {
      this.pdf.set(await this.repository.finalize(id));
    } catch (e) {
      this.error.set(e);
      this.pdfError.set(e);
      throw e;
    } finally {
      this.isFinalizing.set(false);
    }
  }

  uploadSignature(
    id: number,
    role: ComplaintSignatureRole,
    request: ComplaintSignatureCreateRequest
  ): Promise<void> {
    return this.repository.uploadSignature(id, role, request);
  }
}
